import React from 'react'

import { alpha, Box, darken, Typography } from "@mui/material"
import { currencyCode } from "@signals"
import { AppRetailerBlock } from "@components"
import AnalyzerPopover from "Pages/AnalyzersV2/@components/Popover"
import { useCategoriesPopover } from "Pages/AnalyzersV2/@components/CategoriesTable/@hooks"


export default function priceColumn(label) {

	return {
		name: label,
		render: ({ value, id_master_provider_translation, id_site_translation, ico, price_data, evolutionFilter }) => <RenderPriceColumn
			priceData={price_data}
			provider={id_master_provider_translation}
			providerIcon={ico}
			value={value}
			evolutionFilter={evolutionFilter}
			site={id_site_translation}
		/>,
	}
}


function RenderPriceColumn({ value, provider, providerIcon, priceData, evolutionFilter, site }) {

	const { isOpenPopover, onClosePopover, onOpenPopover } = useCategoriesPopover()

	return <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
		<Box
			onClick={e => onOpenPopover(e.currentTarget)}
			sx={{
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				p: 1,
				border: 2,
				borderRadius: "5px",
				borderColor: !!priceData?.color ? priceData?.color : "transparent",
				backgroundColor: !!priceData?.color ? alpha(priceData?.color, 0.2) : "transparent",
				width: 140,
				height: 100,
				cursor: 'pointer',
				'&:hover': {
					borderColor: !!priceData?.color ? darken(priceData?.color, 0.3) : "transparent",
				}
			}}>
			<Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1, flexDirection: "column" }}>
				<Typography variant="subtitle1">{!!value ? `${value} ${currencyCode.value}` : "N/A"}</Typography>
				<AppRetailerBlock retailer={provider || site} icon={providerIcon}/>
			</Box>
		</Box>
		<AnalyzerPopover isOpen={isOpenPopover} onClose={onClosePopover} data={{ evolutionFilter, price_data: priceData }}/>
	</Box>
}